import { useCallback } from 'react'

// One ref callback that fills both the component's own ref (for focus
// management) and the caller's forwarded one.
export const useMergedRef = <E>(
  local: React.MutableRefObject<E | null>,
  forwarded: React.Ref<E>,
): React.RefCallback<E> =>
  useCallback(
    (node: E | null) => {
      local.current = node
      if (typeof forwarded === 'function') forwarded(node)
      else if (forwarded) {
        ;(forwarded as React.MutableRefObject<E | null>).current = node
      }
    },
    [local, forwarded],
  )
